import { useEffect, useState } from "react";

const KEY = "anford-cookie-consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);
  const choose = (val) => {
    localStorage.setItem(KEY, val);
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div data-testid="cookie-consent-banner" className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-xl rounded-2xl border border-navy/10 bg-white/95 p-5 shadow-2xl backdrop-blur-xl sm:left-6 sm:right-auto">
      <p className="text-sm font-semibold text-navy-ink">Your privacy matters</p>
      <p className="mt-1 text-sm leading-relaxed text-slate2">
        ANFORD uses cookies to understand how visitors use this website and to improve your experience.
      </p>
      <div className="mt-4 flex gap-3">
        <button data-testid="cookie-accept-button" onClick={() => choose("accepted")} className="rounded-full bg-navy px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-navy-deep">
          Accept
        </button>
        <button data-testid="cookie-decline-button" onClick={() => choose("declined")} className="rounded-full border border-navy/20 px-5 py-2 text-sm font-semibold text-navy transition-colors hover:border-navy/50">
          Decline
        </button>
      </div>
    </div>
  );
}
